import {
    BB_BETFEED_ENDPOINT,
    BB_BETFEED_FILTER_MOST_POPULAR,
    POPULAR_BETS_PAGE,
    BB_BETFEED_LOADING_STATES,
} from '../../constants';
import { get } from '../../../../shared/utils/http';
import { initialiseCommonStore } from '../../../../shared/components/react/CommonDataStore/actions';
import { buildSpectateUrl } from '../../../../spa/Utils/Spectate';

import {
    betcardsLoadSuccess,
    betcardsErrorOccurred,
    startListeningForWsUpdates,
    stopListeningForWsUpdates,
    startListeningForWsNumberOfPeopleBettedUpdates,
    stopListeningForWsNumberOfPeopleBettedUpdates,
    updateCommonStoreWsData,
    updateNumberOfPeopleBetsWsData,
    selectFilterOption,
    betfeedLoading,
} from '../../app/actions/betfeedActions';

import { isBetfeedWidgetEnabled } from '../../app/utils';

import {
    BETFEED_WIDGET_SPORT_CHANGE,
} from '../../app/actions/betfeedActionTypes';

import mainSocket from '../../../../shared/services/mainSocketClass';
import betfeedSocket from '../../app/betfeedSocket';


export const updateWidgetSport = (sportSlug, sportName) => {
    return {
        type: BETFEED_WIDGET_SPORT_CHANGE,
        sportSlug,
        sportName,
    };
};

/**
 * Fetch betcards from backend
 * @param {function} wsEventListener callback for websocket updates
 * @param {function} wsEventListenerNumberOfPeopleBets callback for websocket updates
 * @param {function} loadedCallbacks callbacks called when finished loading
 * @returns {array} array of betcard objects
 */
export const getBetCards = (wsEventListener, wsEventListenerNumberOfPeopleBets, { lazyLoadHasLoaded, lazyLoadIsEmpty }) => {

    return async (dispatch, getState) => {
        if (!isBetfeedWidgetEnabled()) {
            dispatch(betcardsErrorOccurred(true));
            lazyLoadIsEmpty();

            return;
        }

        try {
            dispatch([
                betcardsErrorOccurred(false),
                betfeedLoading(BB_BETFEED_LOADING_STATES.LOADING),
            ]);
            const endPoint = buildSpectateUrl(`${BB_BETFEED_ENDPOINT}`);
            const { betcards: { sportName, sportSlug, displayType } } = getState();
            const sport = `${sportName && sportSlug ? `&sports=[${sportSlug}]` : ''}`;
            const params = `sorting=${BB_BETFEED_FILTER_MOST_POPULAR.id}&limit=${displayType === POPULAR_BETS_PAGE ? 10 : 5 }&bet_type=singles${sport}&is_top_x=1`;
            const response = await get(`${endPoint}?${params}`);
            if (!response.ok) {
                throw new Error('Betfeed Request Failed');
            }
            const data = await response.json();

            dispatch([
                initialiseCommonStore(data.events),
                betcardsLoadSuccess(data),
                betfeedLoading(BB_BETFEED_LOADING_STATES.LOADED),
            ]);

            if (Array.isArray(data.betcards) && data.betcards.length) {
                dispatch(startListeningForWsUpdates(data));
                dispatch(startListeningForWsNumberOfPeopleBettedUpdates(data));
                mainSocket.onWsEventUpdate(wsEventListener);
                betfeedSocket.onWsEventUpdate(wsEventListenerNumberOfPeopleBets);
                lazyLoadHasLoaded();
            } else {
                lazyLoadIsEmpty();
            }
        } catch (e) {
            dispatch(betcardsErrorOccurred(true));
            lazyLoadIsEmpty();
        }

    };
};

export {
    betcardsLoadSuccess,
    betcardsErrorOccurred,
    startListeningForWsUpdates,
    stopListeningForWsUpdates,
    startListeningForWsNumberOfPeopleBettedUpdates,
    stopListeningForWsNumberOfPeopleBettedUpdates,
    updateCommonStoreWsData,
    updateNumberOfPeopleBetsWsData,
    selectFilterOption,
};
